import {
  FolderOpenOutlined,
  FolderOutlined,
  TableOutlined,
  MenuOutlined
} from '@ant-design/icons';
import { Tree } from 'antd';
import arrayMove from 'array-move';
import React, { useEffect, useState } from 'react';
import style from './index.scss';

function WidgetTree(props) {
  const [tree, setTree] = useState(props.tree);
  const [expandedKeys, setExpandedKeys] = useState([]);
  // const treeData = transform(tree)

  const onSelect = (selectedKeys, info) => {
    if (info.node.type === 'COLUMN') {
      const widget = getParent(info.node);
      props.onSelect['WIDGET']({ groupName: widget.groupName });
    }
    props.onSelect[info.node.type]({ groupName: info.node.key });
  };

  const getWidgetKeys = (tree) => {
    return transform(tree).map((wg) => wg.key);
  };

  const getParent = (node) => {
    switch (node.type) {
      case 'WIDGET':
        const group = tree.find((gp) =>
          gp.widgets.find((w) => w.groupName === node.key)
        );
        return group;
      case 'COLUMN':
        const widget = tree
          .map((gp) => gp.widgets)
          .flat()
          .find((w) => w.groups.find((w) => w.columnId === node.key));
        return widget;
      default:
        return '';
    }
  };

  const onDrop = (info) => {
    const dragged = info.dragNode;
    if (
      info.node.type === dragged.type &&
      getParent(info.node) === getParent(dragged)
    ) {
      let groupItems;
      if (dragged.type === 'COLUMN') {
        groupItems = getParent(dragged).groups;
      } else if (dragged.type === 'WIDGET') {
        groupItems = getParent(dragged).widgets;
      } else {
        groupItems = tree;
      }
      const oldIndex = groupItems.findIndex(
        (i) =>
          dragged.key === (dragged.type === 'COLUMN' ? i.columnId : i.groupName)
      );
      const updatedGroupItems =
        info.dropPosition > 0
          ? arrayMove(groupItems, oldIndex, info.dropPosition - 1)
          : groupItems;

      //update local state
      if (dragged.type === 'COLUMN') {
        const widget = { ...getParent(dragged), groups: updatedGroupItems };

        let oldGroup = getParent({
          key: getParent(dragged).groupName,
          type: 'WIDGET'
        });

        const widgetIndex = oldGroup.widgets.findIndex(
          (w) => w.groupName === widget.groupName
        );
        oldGroup.widgets[widgetIndex] = widget;

        const widgetGroupIndex = tree.findIndex(
          (wg) => wg.groupName === oldGroup.groupName
        );

        let newTree = [...tree];
        newTree[widgetGroupIndex] = oldGroup;
        setTree(newTree);
      } else if (dragged.type === 'WIDGET') {
        const oldGroup = { ...getParent(dragged), widgets: updatedGroupItems };

        const widgetGroupIndex = tree.findIndex(
          (wg) => wg.groupName === oldGroup.groupName
        );

        let newTree = [...tree];
        newTree[widgetGroupIndex] = oldGroup;
        setTree(newTree);
      }
      //send update to parent
      props.onSortItems[dragged.type](updatedGroupItems);
    }
  };

  const transform = (tree) => {
    if (!tree) return [];
    return tree.map((t) => {
      return {
        title: t.groupName,
        key: t.columnId || t.groupName,
        icon: t.widgets ? null : t.groups ? (
          props.selectedWidget === t.groupName ? (
            <FolderOpenOutlined />
          ) : (
            <FolderOutlined />
          )
        ) : (
          <TableOutlined />
        ),
        type: t.widgets ? 'GROUP' : t.groups ? 'WIDGET' : 'COLUMN',
        children: transform(t?.widgets || t?.groups)
      };
    });
  };

  useEffect(() => {
    setTree([]);
    setTree(props.tree);
    setExpandedKeys(expandedKeys || getWidgetKeys(props.tree));
  }, [props.tree]);

  return (
    <div>
      <div className={style.widgetTreeContainer}>
        {tree.length > 0 && (
          <Tree
            expandedKeys={expandedKeys}
            showIcon
            draggable
            blockNode
            onSelect={onSelect}
            treeData={transform(tree)}
            onExpand={(expandedKeys) => {
              setExpandedKeys(expandedKeys);
            }}
            onDrop={onDrop}
            titleRender={(nodeData) => (
              <span className={style.treeHoverIcon}>
                {nodeData.title}
                <MenuOutlined />
              </span>
            )}
          />
        )}
      </div>
    </div>
  );
}

export default WidgetTree;
